<template>
  <div class="adjust-custom-padding">
    <div class="w-100 flex-column d-flex justify-content-center">
      <div
        @click="toggleView('showPanel')"
        v-if="!showPanel"
        class="pointer mt-5"
      >
        <div class="createjob-allocate-container w-100">
          <div
            class="
              d-flex
              align-items-center
              flex
              justify-content-between
              pointer
            "
          >
            <div class="createjobs-allocate-main-heads">Tag Panelist</div>
            <div class="d-flex align-items-center">
              <div
                class="d-flex align-items-center ml-2"
                v-if="
                  validationObj.allocateData.assignedPanelist.$dirty &&
                  !validationObj.allocateData.assignedPanelist.required
                "
              >
                <img
                  src="../../../assets/img/newcreatejob/interviewprocess/erroeicon.svg"
                  alt=""
                />
                <span class="ip-errortxt ml-1">Please select panelist</span>
              </div>
              <div>
                <img
                  class="ml-3"
                  v-show="!showPanel"
                  src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                  alt=""
                />
                <img
                  v-show="showPanel"
                  class="ml-3"
                  src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="p-0 w-100 mt-5 createjob-allocate-container">
          <div class="pointer" @click="toggleView('showPanel')">
            <div
              class="d-flex align-items-center justify-content-between m-15-25"
            >
              <div class="createjobs-allocate-main-heads">Tag Panelist</div>
              <div class="d-flex align-items-center">
                <div>
                  <img
                    v-show="!showPanel"
                    src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                    alt=""
                  />
                  <img
                    v-show="showPanel"
                    class="ml-3"
                    src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="m-15-25">
            <div class="d-flex allocateradios">
              <b-form-radio-group
                :options="options"
                v-model="validationObj.allocateData.requiredPanel.$model"
                @change="modifyPanelData"
              ></b-form-radio-group>
            </div>
            <div class="d-flex align-items-center">
              <div
                v-if="allocateData.requiredPanel === 'partpanelist'"
                class="d-flex align-items-center pointer mt-3"
                @click="openModal('panelist')"
              >
                <img
                  src="../../../assets/img/newcreatejob/interviewprocess/addplus.svg"
                  alt=""
                />
                <span class="createjobs-ip-add-txt ml-2">Panelist</span>
              </div>
              <div
                class="d-flex align-items-center ml-2 mt-3"
                v-if="
                  validationObj.allocateData.assignedPanelist.$dirty &&
                  !validationObj.allocateData.assignedPanelist.required
                "
              >
                <img
                  src="../../../assets/img/newcreatejob/interviewprocess/erroeicon.svg"
                  alt=""
                />
                <span class="ip-errortxt ml-1">Please select panelist</span>
              </div>
            </div>
            <div class="d-flex flex-wrap">
              <div
                class="
                  createjob-ip-evaluators
                  d-flex
                  align-items-center
                  mt-2
                  mr-2
                "
                v-for="user in listPanels"
                :key="user.userID"
              >
                {{ user.username }}
                <img
                  @click="removePanel(user.userID)"
                  src="../../../assets/img/newcreatejob/interviewprocess/tagclose.svg"
                  class="ml-2 mt-1 pointer"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        @click="toggleView('showRecruiter')"
        v-if="!showRecruiter"
        class="pointer mt-3"
      >
        <div
          class="createjob-allocate-container w-100"
          :class="{
            error: validationObj.currentRecuiterData.$error,
          }"
        >
          <div
            class="
              d-flex
              align-items-center
              flex
              justify-content-between
              pointer
            "
          >
            <div class="createjobs-allocate-main-heads">Tag Recruiters</div>

            <div class="d-flex align-items-center">
              <div
                class="d-flex align-items-center"
                v-if="!allocateData.recruiterConfig.common"
              >
                <span class="createjobs-ip-testcards-noti-txt"
                  >Positions Left: {{ positionsLeft }}</span
                >
              </div>
              <div>
                <img
                  class="ml-3"
                  v-show="!showRecruiter"
                  src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                  alt=""
                />
                <img
                  v-show="showRecruiter"
                  class="ml-3"
                  src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="p-0 w-100 mt-3 createjob-allocate-container">
          <div class="w-100 pointer" @click="toggleView('showRecruiter')">
            <div
              class="d-flex align-items-center justify-content-between m-15-25"
            >
              <div
                class="
                  w-100
                  d-flex
                  align-items-center
                  flex
                  justify-content-between
                  pointer
                "
              >
                <div class="createjobs-allocate-main-heads">
                  Tag Recruiters<span class="asterik">*</span>
                </div>

                <div class="d-flex align-items-center gap-15px">
                  <div
                    v-if="isJdApproved"
                    @click.stop="showJobPosModal = true"
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div style="width: 150px">
                      <div class="position-status-font">Position status:</div>
                      <div class="d-flex align-items-center mt-1">
                        <div
                          class="red-line"
                          :class="
                            positionBarPercentage[4] !== '0.00%' ? 'mr-1' : ''
                          "
                          :style="{ width: positionBarPercentage[4] }"
                        ></div>
                        <div
                          class="orange-line"
                          :class="
                            positionBarPercentage[0] !== '0.00%' ? 'mr-1' : ''
                          "
                          :style="{ width: positionBarPercentage[0] }"
                        ></div>
                        <div
                          class="golden-line"
                          :class="
                            positionBarPercentage[2] !== '0.00%' ? 'mr-1' : ''
                          "
                          :style="{ width: positionBarPercentage[2] }"
                        ></div>
                        <div
                          class="grey-line"
                          :class="
                            positionBarPercentage[3] !== '0.00%' ? 'mr-1' : ''
                          "
                          :style="{ width: positionBarPercentage[3] }"
                        ></div>
                        <div
                          class="green-line"
                          :class="
                            positionBarPercentage[1] !== '0.00%' ? 'mr-1' : ''
                          "
                          :style="{ width: positionBarPercentage[1] }"
                        ></div>
                      </div>
                    </div>
                    <div>
                      <img
                        src="../../../assets/New-job-dashboard/expand-icon.svg"
                        class="mb-1"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    class="
                      d-flex
                      align-items-center
                      createjobs-ip-testcards-noti-txt
                      pt-1
                    "
                    v-if="!allocateData.recruiterConfig.common"
                  >
                    Positions Left: {{ positionsLeft }}
                  </div>
                  <div>
                    <img src="../../../assets/img/newkanban/Line.svg" alt="" />
                  </div>
                  <div class="d-flex align-items-center">
                    <div
                      @click.stop="
                        isRecruiterDataValid
                          ? ($emit('add-recruiter'), applyChangesToAll())
                          : ''
                      "
                      class="d-flex align-items-center"
                      :class="
                        isRecruiterDataValid ? 'pointer' : 'disabled-kanban-img'
                      "
                    >
                      <img
                        src="../../../assets/img/newcreatejob/interviewprocess/addplus.svg"
                        alt=""
                      />
                      <span class="createjobs-ip-add-txt ml-2">Recruiter</span>
                    </div>
                  </div>
                  <div>
                    <img
                      v-show="!showRecruiter"
                      src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                      alt=""
                    />
                    <img
                      v-show="showRecruiter"
                      src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="m-15-25 px-3 py-2">
            <div class="new-allocate-subhead">Position ID's</div>
            <div class="mt-1 d-flex align-items-center">
              <div class="position-id-subtext">
                <img
                  class="mr-1 mb-1"
                  src="../../../assets/New-job-dashboard/n-icon.svg"
                  alt=""
                />
                The Number of Recruiters working on that position ID
              </div>
              <div class="mx-3" v-if="isJdApproved">
                <img
                  class="mb-1"
                  src="../../../assets/New-job-dashboard/sm-line.svg"
                  alt=""
                />
              </div>
              <div class="position-id-subtext" v-if="isJdApproved">
                <img
                  class="mr-1 mb-1"
                  src="../../../assets/New-job-dashboard/info-sm-icon.svg"
                  alt=""
                />
                Position IDs and related data will be updated on each action.
              </div>
            </div>
            <draggable
              class="w-100 d-flex align-items-center flex-wrap position mt-2"
              ref="firstDraggable"
              style="gap: 15px"
              v-model="draggableIDs"
              :group="{ name: 'recruiters', pull: 'clone', put: false }"
            >
              <div
                class="drag-container d-flex align-items-center"
                :class="
                  getPositionById(id).count > 0
                    ? 'drag-selected-container'
                    : 'drag-container'
                "
                v-for="(id, index) in draggableIDs"
                :key="index"
              >
                <div class="mr-2 mb-1">
                  <img
                    v-if="getPositionById(id).count > 0"
                    src="../../../assets/New-job-dashboard/white-draganddrop.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../../assets/New-job-dashboard/black-draganddrop.svg"
                    alt=""
                  />
                </div>

                <div>{{ id }}</div>
                <div
                  class="ml-2 drag-selected-container-number"
                  v-if="getPositionById(id).count > 0"
                >
                  {{ getPositionById(id).count }}
                </div>
              </div>
            </draggable>

            <div class="allocate-pagetable w-100 mt-3 position-relative">
              <div class="w-95 allocate-table-header d-flex align-items-center">
                <div class="w-30">Recruiters</div>
                <div class="w-40">Position ID</div>
                <div class="w-30">Panelist</div>
              </div>
              <div
                v-for="(recruiter, index) in currentRecuiterData"
                :key="index"
                class="w-100 d-flex align-items-center flex-column"
              >
                <div class="w-100 d-flex align-items-center">
                  <div
                    class="
                      d-flex
                      align-items-start
                      allocate-recruiter-table-body-cards
                      mt-2
                      w-95
                      position-relative
                    "
                    :class="{
                      error:
                        validationObj.currentRecuiterData.$each[index].$error,
                    }"
                    style="height: unset"
                  >
                    <div class="allocate-tablecard-line py-1"></div>
                    <div class="position-relative m-2" style="width: 28%">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                        @blur="closeDropdownOnFocusOut(index)"
                        tabindex="0"
                        style="width: 175px"
                        :class="{
                          'disabled-color':
                            isJdApproved && recruiter.positionIDs.length !== 0,
                          'global-disabledField':
                            isJdApproved && recruiter.positionIDs.length !== 0,
                        }"
                      >
                        <div
                          @click="
                            isJdApproved && recruiter.positionIDs.length !== 0
                              ? ''
                              : checkToGetRecruiter(index)
                          "
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                          :class="{
                            'global-disabledField':
                              isJdApproved &&
                              recruiter.positionIDs.length !== 0,
                          }"
                        >
                          <div
                            class="
                              allocate-tablecard-dd-head
                              w-90
                              text-truncate
                            "
                          >
                            {{
                              recruiter.recruiterData
                                ? recruiter.recruiterData.username
                                : "Select"
                            }}
                          </div>
                          <div>
                            <img
                              v-show="!recruiter.showRecDropDown"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="recruiter.showRecDropDown"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="recruiter.showRecDropDown"
                            style="top: 27px"
                            class="newInt-radio-dropdown p-0"
                          >
                            <b-overlay :show="recLoader" rounded="sm">
                              <b-form-group
                                class="sec-mcq-datacard"
                                :class="
                                  recLoader
                                    ? 'allocate-req-dropdown-height'
                                    : 'allocate-req-dropdown'
                                "
                              >
                                <b-form-radio-group
                                  class="
                                    newInt-radio-dropdown-inner-content
                                    w-100
                                  "
                                  size="sm"
                                  :options="recruiterList"
                                  v-model="recruiter.selectedRecruiter"
                                  @change="hideRecruiter(index)"
                                  buttons
                                  stacked
                                  :disabled="
                                    isJdApproved &&
                                    recruiter.positionIDs.length !== 0
                                  "
                                >
                                </b-form-radio-group>
                              </b-form-group>
                            </b-overlay>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-40 m-2">
                      <draggable
                        class="
                          w-100
                          d-flex
                          align-items-center
                          flex-wrap
                          position
                        "
                        style="gap: 15px"
                        ref="secondDraggable"
                        v-model="recruiter.positionIDs"
                        group="recruiters"
                        @add="(event) => addPositionID(event, index)"
                        @start="dragPositionID(index)"
                      >
                        <template v-if="recruiter.positionIDs.length">
                          <div
                            class="drag-container d-flex align-items-center"
                            v-for="(posID, ind) in recruiter.positionIDs"
                            :key="ind"
                          >
                            <div class="mr-2 mb-1">
                              <img
                                src="../../../assets/New-job-dashboard/black-draganddrop.svg"
                                alt=""
                              />
                            </div>
                            <div>{{ posID }}</div>
                            <div
                              v-if="
                                !isJdApproved ||
                                (isJdApproved &&
                                  recruiter.positionIDs.length !== 1)
                              "
                              class="ml-2 mb-1"
                              :class="{
                                'disable-icon': deletePosLoader,
                                'global-disabledField': deletePosLoader,
                              }"
                              @click.stop="
                                !deletePosLoader &&
                                  deletePositionID(index, posID)
                              "
                            >
                              <img
                                src="../../../assets/img/newcreatejob/pos-id-close.svg"
                                alt=""
                              />
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div class="not-selected-font mt-1">
                            No Position ID is assigned
                          </div>
                        </template>
                      </draggable>
                    </div>
                    <div class="w-30 m-2 d-flex align-items-center">
                      <div
                        :class="[
                          'd-flex align-items-center ',
                          recruiter &&
                          recruiter.selectedPanels &&
                          recruiter.selectedPanels.includes('internal')
                            ? 'panel-selected-div'
                            : 'panel-unselected-div',
                        ]"
                      >
                        <div class="common-white-checkbox">
                          <b-form-checkbox
                            v-model="recruiter.selectedPanels"
                            value="internal"
                            @change="applyChangesToAll"
                            :disabled="
                              allocateData.requiredPanel === 'nopanelist'
                            "
                          >
                          </b-form-checkbox>
                        </div>
                        <div>Internal</div>
                      </div>
                      <div
                        :class="[
                          'd-flex align-items-center ml-3',
                          recruiter &&
                          recruiter.selectedPanels &&
                          recruiter.selectedPanels.includes('external')
                            ? 'panel-selected-div'
                            : 'panel-unselected-div',
                        ]"
                      >
                        <div class="common-white-checkbox">
                          <b-form-checkbox
                            v-model="recruiter.selectedPanels"
                            value="external"
                            @change="applyChangesToAll"
                          >
                          </b-form-checkbox>
                        </div>
                        <div>External</div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="currentRecuiterData.length > 1"
                    class="w-5 d-flex align-items-center justify-content-end"
                  >
                    <img
                      @click="deleteRecruiter(index)"
                      src="../../../assets/img/newcreatejob/interviewprocess/delete.svg"
                      alt=""
                      class="pointer"
                    />
                  </div>
                </div>
                <div v-if="currentRecuiterData.length > 1" class="w-90 my-2">
                  <div
                    class="
                      w-100
                      text-right
                      ct-table-switch
                      d-flex
                      align-items-center
                      justify-content-end
                      apply-font
                    "
                    v-if="index === 0"
                  >
                    <b-form-checkbox
                      switch
                      v-model="localApplyToAll"
                      @change="applyChangesToAllRecs"
                    ></b-form-checkbox>
                    Apply to all
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        @click="toggleView('showVendor')"
        v-if="!showVendor"
        class="pointer mt-3 mb-3"
      >
        <div class="createjob-allocate-container w-100">
          <div
            class="
              d-flex
              align-items-center
              flex
              justify-content-between
              pointer
            "
          >
            <div class="createjobs-allocate-main-heads">
              Tag Vendors
              {{
                interviewProcess === null ||
                !Object.keys(interviewProcess).length
                  ? "(Please select an interview process)"
                  : ""
              }}
            </div>
            <div class="d-flex">
              <div
                class="d-flex align-items-center mr-2"
                v-if="
                  tempVendor.length !== 0 &&
                  validationObj.tempVendor.$dirty &&
                  !validationObj.tempVendor.required
                "
              >
                <img
                  src="../../../assets/img/newcreatejob/interviewprocess/erroeicon.svg"
                  alt=""
                />
                <span class="ip-errortxt ml-1">Please select panelist</span>
              </div>
              <img
                v-show="!showVendor"
                src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                alt=""
              />
              <img
                v-show="showVendor"
                class="ml-3"
                src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <div
          class="p-0 w-100 mt-3 mb-3 createjob-allocate-container"
          :class="{ 'mb-10r': increaseMargin }"
        >
          <div class="pointer w-100" @click="toggleView('showVendor')">
            <div
              class="d-flex align-items-center justify-content-between m-15-25"
            >
              <div class="createjobs-allocate-main-heads">
                Tag Vendors
                {{
                  interviewProcess === null ||
                  !Object.keys(interviewProcess).length
                    ? "(Please select an interview process)"
                    : ""
                }}
              </div>
              <div class="d-flex">
                <div
                  class="d-flex align-items-center mr-2"
                  v-if="
                    tempVendor.length !== 0 &&
                    validationObj.tempVendor.$dirty &&
                    !validationObj.tempVendor.required
                  "
                >
                  <img
                    src="../../../assets/img/newcreatejob/interviewprocess/erroeicon.svg"
                    alt=""
                  />
                  <span class="ip-errortxt ml-1">Please select panelist</span>
                </div>
                <img
                  v-show="!showVendor"
                  src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                  alt=""
                />
                <img
                  v-show="showVendor"
                  class="ml-3"
                  src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="m-15-25">
            <div class="mt-3">
              <div class="recruiters-card-main-head">Configuration:</div>
              <div class="d-flex allocateradios mt-2">
                <b-form-radio-group
                  :options="configoptions"
                  v-model="allocateData.vendorConfig.common"
                  @change="$forceUpdate()"
                  text-field="text"
                  value-field="value"
                ></b-form-radio-group>
              </div>
            </div>
            <template v-if="allocateData.vendorConfig.common">
              <div class="d-flex align-items-center mt-3">
                <div @click="showAllocateVendor = true" class="pointer">
                  <img
                    src="../../../assets/img/newcreatejob/interviewprocess/addplus.svg"
                    alt=""
                  />
                  <span class="createjobs-ip-add-txt ml-2">Vendor</span>
                </div>
              </div>
              <div class="d-flex flex-wrap">
                <div
                  class="createjob-ip-evaluators d-flex align-items-center mt-2"
                  :class="index == 0 ? '' : 'ml-2'"
                  v-for="(vendor, index) in commonVendorData.vendor"
                  :key="vendor.vendorID"
                >
                  {{ vendor.name }}
                  <img
                    @click="$emit('remove-vendor', index)"
                    src="../../../assets/img/newcreatejob/interviewprocess/tagclose.svg"
                    class="ml-2 mt-1 pointer"
                    alt=""
                  />
                </div>
              </div>
              <template v-if="commonVendorData.vendor.length">
                <div class="mt-3">
                  <b-row>
                    <b-col>
                      <div class="newmodal-input-label">
                        Rounds to Take<span class="asterik">*</span>
                      </div>
                      <div class="position-relative mt-1 w-100">
                        <div
                          class="
                            w-100
                            createjob-dd-des
                            bg-white
                            select-eval-dd
                            position-relative
                          "
                          :class="{
                            error:
                              validationObj.commonVendorData.noOfRoundsToTake
                                .$error,
                          }"
                        >
                          <div
                            @click="showRoundsToTake = !showRoundsToTake"
                            ref="rounds"
                            class="
                              h-100
                              d-flex
                              align-items-center
                              justify-content-between
                              pointer
                            "
                          >
                            <div class="select-evaldd-head">
                              {{
                                commonVendorData.noOfRoundsToTake === null
                                  ? "Select"
                                  : commonVendorData.noOfRoundsToTake
                              }}
                            </div>
                            <div>
                              <img
                                v-show="!showRoundsToTake"
                                src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                                alt=""
                              />
                              <img
                                v-show="showRoundsToTake"
                                src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            class="newInt-required-validation-font mt-1"
                            v-if="
                              validationObj.commonVendorData.noOfRoundsToTake
                                .$dirty &&
                              !validationObj.commonVendorData.noOfRoundsToTake
                                .required
                            "
                          >
                            Required
                          </div>
                          <!-- if u want to use radio group go vth the below div -->
                          <div class="w-100">
                            <div
                              v-if="showRoundsToTake"
                              v-closable="{
                                exclude: ['rounds'],
                                handler: 'hideNoOfRounds',
                              }"
                              style="top: 38px"
                              class="bg-white newInt-radio-dropdown p-0"
                            >
                              <b-form-group class="sec-mcq-datacard">
                                <div class="allocate-rounds-group-container">
                                  <b-form-radio-group
                                    class="
                                      newInt-radio-dropdown-inner-content
                                      w-100
                                    "
                                    size="sm"
                                    :options="roundOptions"
                                    v-model="
                                      validationObj.commonVendorData
                                        .noOfRoundsToTake.$model
                                    "
                                    @change="hideNoOfRounds"
                                    buttons
                                    stacked
                                  >
                                  </b-form-radio-group>
                                </div>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="newmodal-input-label">
                        No. of Candidates to Push<span class="asterik">*</span>
                      </div>
                      <div class="position-relative newmodalinputbox mt-1">
                        <b-form-input
                          min="1"
                          type="number"
                          placeholder="Enter"
                          v-model="
                            validationObj.commonVendorData.noOfCandidatesToPush
                              .$model
                          "
                          :class="{
                            error:
                              validationObj.commonVendorData
                                .noOfCandidatesToPush.$error,
                          }"
                          @keydown="restrictInput"
                        >
                        </b-form-input>
                        <div
                          class="newInt-required-validation-font mt-1"
                          v-if="
                            validationObj.commonVendorData.noOfCandidatesToPush
                              .$dirty &&
                            !validationObj.commonVendorData.noOfCandidatesToPush
                              .required
                          "
                        >
                          Required
                        </div>
                        <div
                          class="newInt-required-validation-font mt-1"
                          v-else-if="
                            !validationObj.commonVendorData.noOfCandidatesToPush
                              .minValue
                          "
                        >
                          Should be greater than 0
                        </div>
                        <div
                          class="newInt-required-validation-font mt-1"
                          v-else-if="
                            validationObj.commonVendorData.noOfCandidatesToPush
                              .$dirty &&
                            !validationObj.commonVendorData.noOfCandidatesToPush
                              .maxLength
                          "
                        >
                          Limit exceeded
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="newmodal-input-label">
                        Panelist<span class="asterik">*</span>
                      </div>
                      <div class="position-relative mt-1 w-100">
                        <div
                          class="
                            w-100
                            createjob-dd-des
                            select-eval-dd
                            position-relative
                          "
                          :class="{
                            error:
                              validationObj.commonVendorData.panelist.$error,
                            'disabled-color':
                              commonVendorData.noOfRoundsToTake === 0,
                          }"
                          :style="
                            commonVendorData.noOfRoundsToTake === 0
                              ? 'background-color: #eeeeee;'
                              : ''
                          "
                        >
                          <div
                            @click="openPanelInCommon"
                            ref="panelForVendor"
                            class="
                              h-100
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                            :class="{
                              pointer: commonVendorData.noOfRoundsToTake !== 0,
                            }"
                          >
                            <div class="select-evaldd-head text-capitalize">
                              {{ commonVendorData.panelist || "Select" }}
                            </div>
                            <div>
                              <img
                                v-show="!showPanelInComVendor"
                                src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                                alt=""
                              />
                              <img
                                v-show="showPanelInComVendor"
                                src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            class="newInt-required-validation-font mt-1"
                            v-if="
                              validationObj.commonVendorData.panelist.$dirty &&
                              !validationObj.commonVendorData.panelist.required
                            "
                          >
                            Required
                          </div>
                          <!-- if u want to use radio group go vth the below div -->
                          <div class="w-100">
                            <div
                              v-if="showPanelInComVendor"
                              v-closable="{
                                exclude: ['panelForVendor'],
                                handler: 'hidePanelForVendor',
                              }"
                              style="top: 38px"
                              class="bg-white newInt-radio-dropdown p-0"
                            >
                              <b-form-group class="sec-mcq-datacard">
                                <b-form-radio-group
                                  class="
                                    newInt-radio-dropdown-inner-content
                                    w-100
                                  "
                                  size="sm"
                                  :options="panelTypeOptions"
                                  v-model="
                                    validationObj.commonVendorData.panelist
                                      .$model
                                  "
                                  @change="hidePanelForVendor"
                                  buttons
                                  stacked
                                >
                                </b-form-radio-group>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="mt-3">
                  <b-row>
                    <b-col>
                      <div class="newmodal-input-label">
                        Tag Recruiters<span class="asterik">*</span>
                      </div>
                      <div class="position-relative mt-1 w-100">
                        <div
                          class="
                            w-100
                            createjob-dd-des
                            bg-white
                            select-eval-dd
                            position-relative
                          "
                          :class="{
                            error:
                              validationObj.commonVendorData.taggedRecruiters
                                .$error,
                          }"
                        >
                          <div
                            @click="showRecInComVendor = !showRecInComVendor"
                            ref="select-recruiter-vendor"
                            class="
                              h-100
                              d-flex
                              align-items-center
                              justify-content-between
                              pointer
                            "
                          >
                            <div class="select-evaldd-head">
                              {{
                                commonVendorData.taggedRecruiters &&
                                commonVendorData.taggedRecruiters.length
                                  ? commonVendorData.taggedRecruiters.length +
                                    " selected"
                                  : "Select"
                              }}
                            </div>
                            <div>
                              <img
                                v-show="!showRecInComVendor"
                                src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                                alt=""
                              />
                              <img
                                v-show="showRecInComVendor"
                                src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            class="newInt-required-validation-font mt-1"
                            v-if="
                              validationObj.commonVendorData.taggedRecruiters
                                .$dirty &&
                              !validationObj.commonVendorData.taggedRecruiters
                                .required
                            "
                          >
                            Required
                          </div>
                          <!-- if u want to use radio group go vth the below div -->
                          <div class="w-100">
                            <div
                              v-if="showRecInComVendor"
                              v-closable="{
                                exclude: ['select-recruiter-vendor'],
                                handler: 'hideDropDown',
                              }"
                              style="top: 38px; left: 0"
                              class="
                                w-100
                                p-2
                                qb-filter-modal-sug
                                sendautomatically
                                pff-checkbox
                                overflow-auto
                              "
                            >
                              <b-form-group
                                class="w-100 min-height-adjustment-sugg"
                              >
                                <b-form-checkbox
                                  class="pointer options wordbreak"
                                  size="sm"
                                  v-for="(
                                    recruiter, index
                                  ) in selectedRecruiterList"
                                  :value="recruiter.userID"
                                  :key="index"
                                  v-model="
                                    validationObj.commonVendorData
                                      .taggedRecruiters.$model
                                  "
                                >
                                  {{ recruiter.username }}
                                </b-form-checkbox>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>
                    <b-col> </b-col>
                    <b-col> </b-col>
                  </b-row>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="allocate-pagetable w-100 mt-3 position-relative">
                <div
                  class="w-95 allocate-table-header d-flex align-items-center"
                >
                  <div class="w-20">Vendors</div>
                  <div class="w-20">Rounds to Take</div>
                  <div class="w-20">No. of Candidates to Push</div>
                  <div class="w-20">Tag Recruiters</div>
                  <div class="w-20">Panelist</div>
                </div>
                <div
                  class="w-100 d-flex align-items-center"
                  v-for="(vendor, index) in tempVendor"
                  :key="index"
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      allocate-recruiter-table-body-cards
                      mt-2
                      w-95
                      position-relative
                    "
                    :class="{
                      error:
                        validationObj.tempVendor.$each[index].$error ||
                        !validationObj.tempVendor.$each[index]
                          .noOfCandidatesToPush.minValue,
                    }"
                  >
                    <div
                      v-show="
                        !validationObj.tempVendor.$each[index].$error &&
                        validationObj.tempVendor.$each[index]
                          .noOfCandidatesToPush.minValue
                      "
                      class="allocate-tablecard-line py-1"
                    ></div>
                    <div
                      v-show="
                        validationObj.tempVendor.$each[index].$error ||
                        !validationObj.tempVendor.$each[index]
                          .noOfCandidatesToPush.minValue
                      "
                      class="allocate-tablecard-line-error py-1"
                    ></div>
                    <div class="w-20 pl-3 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                        tabindex="0"
                        @focusout="
                          closeOnFocusOut(
                            $event,
                            'label-indexed-ven-' + index,
                            index,
                            'tempVendor',
                            'showVendor'
                          )
                        "
                        :ref="'label-indexed-ven-' + index"
                      >
                        <div
                          @click="openVendorsIndep($event, index)"
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                        >
                          <div
                            class="
                              w-90
                              text-truncate
                              allocate-tablecard-dd-head
                            "
                          >
                            {{ vendor.vendor.name }}
                          </div>
                          <div>
                            <img
                              v-show="!tempVendor[index].showVendor"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="tempVendor[index].showVendor"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="tempVendor[index].showVendor"
                            style="top: 27px"
                            class="
                              newInt-radio-dropdown
                              p-0
                              dropdown-height-allocate
                            "
                            @scroll="onVenScroll($event)"
                          >
                            <div class="position-relative search-bar w-100">
                              <span>
                                <img
                                  class="acs-search-pos"
                                  src="../../../assets/img/search-bar-icon.svg"
                                  alt
                                />
                              </span>
                              <b-form-input
                                class="acs-search-input"
                                type="search"
                                placeholder="Search"
                                v-model="searchVendors"
                                debounce="500"
                                @update="getVendors(index)"
                              ></b-form-input>
                            </div>
                            <b-form-group class="sec-mcq-datacard">
                              <b-form-radio-group
                                class="
                                  newInt-radio-dropdown-inner-content
                                  w-100
                                "
                                size="sm"
                                :options="vendorsList"
                                v-model="tempVendor[index].vendor"
                                buttons
                                stacked
                              >
                              </b-form-radio-group>
                            </b-form-group>
                            <div
                              style="margin: auto"
                              v-if="showVendorLoader"
                              class="d-flex justify-content-center mb-3"
                            >
                              <b-spinner label="Loading..."></b-spinner>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-20 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                      >
                        <div
                          @click="
                            tempVendor[index].showRounds =
                              !tempVendor[index].showRounds
                          "
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                        >
                          <div class="allocate-tablecard-dd-head">
                            {{ tempVendor[index].noOfRoundsToTake }}
                          </div>
                          <div>
                            <img
                              v-show="!tempVendor[index].showRounds"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="tempVendor[index].showRounds"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="tempVendor[index].showRounds"
                            style="top: 27px"
                            class="newInt-radio-dropdown p-0"
                          >
                            <b-form-group class="sec-mcq-datacard">
                              <b-form-radio-group
                                class="
                                  newInt-radio-dropdown-inner-content
                                  w-100
                                "
                                size="sm"
                                :options="roundOptions"
                                @change="checkRoundData(index)"
                                v-model="tempVendor[index].noOfRoundsToTake"
                                buttons
                                stacked
                              >
                              </b-form-radio-group>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-20 allocate-table-inputs">
                      <b-form-input
                        min="1"
                        type="number"
                        @keydown="restrictInput"
                        v-model="
                          validationObj.tempVendor.$each[index]
                            .noOfCandidatesToPush.$model
                        "
                        placeholder="Enter"
                      >
                      </b-form-input>
                    </div>
                    <div class="w-20 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                      >
                        <div
                          @click="
                            tempVendor[index].showRec =
                              !tempVendor[index].showRec
                          "
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                        >
                          <div
                            class="
                              w-90
                              text-truncate
                              allocate-tablecard-dd-head
                            "
                          >
                            {{
                              tempVendor[index].taggedRecruiters &&
                              tempVendor[index].taggedRecruiters.length
                                ? tempVendor[index].taggedRecruiters.length +
                                  " selected"
                                : "Select"
                            }}
                          </div>
                          <div>
                            <img
                              v-show="!tempVendor[index].showRec"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="tempVendor[index].showRec"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="tempVendor[index].showRec"
                            style="top: 27px"
                            class="
                              newInt-radio-dropdown
                              p-0
                              dropdown-height-allocate-2
                              ssi
                              aoeinput
                              opt-check
                              sendautomatically
                              pff-checkbox
                            "
                          >
                            <b-form-group
                              class="sec-mcq-datacard"
                              style="width: 100%"
                            >
                              <b-form-checkbox
                                class="pl-4 options pointer"
                                size="sm"
                                name="flavour-4a"
                                v-for="(
                                  recruiter, index1
                                ) in selectedRecruiterList"
                                :value="recruiter.userID"
                                :key="index1"
                                v-model="
                                  validationObj.tempVendor.$each[index]
                                    .taggedRecruiters.$model
                                "
                              >
                                {{ recruiter.username }}
                              </b-form-checkbox>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-20 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                        :class="{
                          'disabled-color':
                            tempVendor[index].noOfRoundsToTake === 0,
                        }"
                      >
                        <div
                          @click="openPanel(index)"
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                          "
                        >
                          <div
                            class="allocate-tablecard-dd-head text-capitalize"
                          >
                            {{ tempVendor[index].panelist }}
                          </div>
                          <div>
                            <img
                              v-show="!tempVendor[index].showPanel"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="tempVendor[index].showPanel"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="tempVendor[index].showPanel"
                            style="top: 27px"
                            class="newInt-radio-dropdown p-0"
                          >
                            <b-form-group class="sec-mcq-datacard">
                              <b-form-radio-group
                                class="
                                  newInt-radio-dropdown-inner-content
                                  w-100
                                "
                                size="sm"
                                :options="panelTypeOptions"
                                buttons
                                v-model="
                                  validationObj.tempVendor.$each[index].panelist
                                    .$model
                                "
                                stacked
                              >
                              </b-form-radio-group>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-5 d-flex align-items-center justify-content-end"
                  >
                    <img
                      @click="deleteVendor(index)"
                      src="../../../assets/img/newcreatejob/interviewprocess/delete.svg"
                      alt=""
                      class="pointer"
                    />
                  </div>
                </div>
                <div class="w-100 d-flex align-items-center">
                  <div
                    :class="{
                      error:
                        validationObj.currentVendorData.$error ||
                        !validationObj.currentVendorData.noOfCandidatesToPush
                          .maxLength ||
                        !validationObj.currentVendorData.noOfCandidatesToPush
                          .minValue,
                    }"
                    class="
                      d-flex
                      align-items-center
                      allocate-recruiter-table-body-cards
                      mt-2
                      w-95
                      position-relative
                    "
                  >
                    <div
                      v-show="
                        validationObj.currentVendorData.$error ||
                        (validationObj.currentVendorData.noOfCandidatesToPush
                          .required &&
                          !validationObj.currentVendorData.noOfCandidatesToPush
                            .minValue) ||
                        !validationObj.currentVendorData.noOfCandidatesToPush
                          .maxLength
                      "
                      class="allocate-tablecard-line-error py-1"
                    ></div>
                    <div
                      v-show="
                        !validationObj.currentVendorData.$error &&
                        validationObj.currentVendorData.noOfCandidatesToPush
                          .minValue &&
                        validationObj.currentVendorData.noOfCandidatesToPush
                          .maxLength
                      "
                      class="allocate-tablecard-line py-1"
                    ></div>
                    <div class="w-20 pl-3 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                      >
                        <div
                          @click="openVendorsIndep"
                          ref="vendor-label-1"
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                        >
                          <div
                            class="
                              w-90
                              text-truncate
                              allocate-tablecard-dd-head
                            "
                          >
                            {{
                              currentVendorData.vendor
                                ? currentVendorData.vendor.name
                                : "Select"
                            }}
                          </div>
                          <div>
                            <img
                              v-show="!currentVendorData.showVendor"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="currentVendorData.showVendor"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="currentVendorData.showVendor"
                            v-closable="{
                              exclude: ['vendor-label-1'],
                              handler: 'hideVendorInIndep',
                            }"
                            style="top: 27px"
                            class="
                              newInt-radio-dropdown
                              p-0
                              dropdown-height-allocate-2
                            "
                            @scroll="onVenScroll($event)"
                          >
                            <div class="position-relative search-bar w-100">
                              <span>
                                <img
                                  class="acs-search-pos"
                                  src="../../../assets/img/search-bar-icon.svg"
                                  alt
                                />
                              </span>
                              <b-form-input
                                class="acs-search-input"
                                type="search"
                                placeholder="Search"
                                v-model="searchVendors"
                                debounce="500"
                                @update="getVendors"
                              ></b-form-input>
                            </div>
                            <b-form-group class="sec-mcq-datacard">
                              <b-form-radio-group
                                class="
                                  newInt-radio-dropdown-inner-content
                                  w-100
                                "
                                size="sm"
                                :options="vendorsList"
                                v-model="
                                  validationObj.currentVendorData.vendor.$model
                                "
                                @change="hideVendorInIndep"
                                buttons
                                stacked
                              >
                              </b-form-radio-group>
                            </b-form-group>
                            <div
                              style="margin: auto"
                              v-if="showVendorLoader"
                              class="d-flex justify-content-center mb-3"
                            >
                              <b-spinner label="Loading..."></b-spinner>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-20 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                      >
                        <div
                          ref="vendor-rounds-1"
                          @click="
                            currentVendorData.showRounds =
                              !currentVendorData.showRounds
                          "
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                        >
                          <div class="allocate-tablecard-dd-head">
                            {{
                              currentVendorData.noOfRoundsToTake === null
                                ? "Select"
                                : currentVendorData.noOfRoundsToTake
                            }}
                          </div>
                          <div>
                            <img
                              v-show="!currentVendorData.showRounds"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="currentVendorData.showRounds"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="currentVendorData.showRounds"
                            v-closable="{
                              exclude: ['vendor-rounds-1'],
                              handler: 'hideRoundInVenIndep',
                            }"
                            style="top: 27px"
                            class="
                              newInt-radio-dropdown
                              p-0
                              dropdown-height-allocate-2
                            "
                          >
                            <b-form-group class="sec-mcq-datacard">
                              <b-form-radio-group
                                class="
                                  newInt-radio-dropdown-inner-content
                                  w-100
                                "
                                size="sm"
                                :options="roundOptions"
                                v-model="
                                  validationObj.currentVendorData
                                    .noOfRoundsToTake.$model
                                "
                                @change="hideRoundInVenIndep"
                                buttons
                                stacked
                              >
                              </b-form-radio-group>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-20 allocate-table-inputs">
                      <b-form-input
                        min="1"
                        type="number"
                        @keydown="restrictInput"
                        v-model="
                          validationObj.currentVendorData.noOfCandidatesToPush
                            .$model
                        "
                        placeholder="Enter"
                      >
                      </b-form-input>
                    </div>
                    <div class="w-20 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                        ref="vendor-rec-1"
                      >
                        <div
                          @click="
                            currentVendorData.showRec =
                              !currentVendorData.showRec
                          "
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            pointer
                          "
                        >
                          <div class="allocate-tablecard-dd-head">
                            {{
                              currentVendorData.taggedRecruiters &&
                              currentVendorData.taggedRecruiters.length
                                ? currentVendorData.taggedRecruiters.length +
                                  " selected"
                                : "Select"
                            }}
                          </div>
                          <div>
                            <img
                              v-show="!currentVendorData.showRec"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="currentVendorData.showRec"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="currentVendorData.showRec"
                            v-closable="{
                              exclude: ['vendor-rec-1'],
                              handler: 'hideRecInVenIndep',
                            }"
                            style="top: 27px"
                            class="
                              newInt-radio-dropdown
                              p-0
                              dropdown-height-allocate-2
                              ssi
                              aoeinput
                              opt-check
                              sendautomatically
                              pff-checkbox
                            "
                          >
                            <b-form-group
                              class="sec-mcq-datacard"
                              style="width: 100%"
                            >
                              <b-form-checkbox
                                class="pl-4 options pointer"
                                size="sm"
                                name="flavour-4a"
                                v-for="(
                                  recruiter, index
                                ) in selectedRecruiterList"
                                :value="recruiter.userID"
                                :key="index"
                                v-model="
                                  validationObj.currentVendorData
                                    .taggedRecruiters.$model
                                "
                              >
                                {{ recruiter.username }}
                              </b-form-checkbox>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-20 position-relative">
                      <div
                        class="
                          allocate-recruiter-dd-headerbox
                          px-2
                          position-relative
                        "
                        :class="{
                          'disabled-color':
                            currentVendorData.noOfRoundsToTake === 0,
                        }"
                      >
                        <div
                          ref="vendor-pan-1"
                          @click="openPanel"
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                          "
                          :class="{
                            pointer: currentVendorData.noOfRoundsToTake !== 0,
                          }"
                        >
                          <div
                            class="allocate-tablecard-dd-head text-capitalize"
                          >
                            {{ currentVendorData.panelist || "Select" }}
                          </div>
                          <div>
                            <img
                              v-show="!currentVendorData.showPanel"
                              src="../../../assets/img/newcreatejob/interviewprocess/downarw.svg"
                              alt=""
                            />
                            <img
                              v-show="currentVendorData.showPanel"
                              src="../../../assets/img/newcreatejob/interviewprocess/uparw.svg"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="w-100">
                          <div
                            v-if="currentVendorData.showPanel"
                            v-closable="{
                              exclude: ['vendor-pan-1'],
                              handler: 'hidePanInIndep',
                            }"
                            style="top: 27px"
                            class="
                              newInt-radio-dropdown
                              p-0
                              dropdown-height-allocate-2
                            "
                          >
                            <b-form-group class="sec-mcq-datacard">
                              <b-form-radio-group
                                class="
                                  newInt-radio-dropdown-inner-content
                                  w-100
                                "
                                size="sm"
                                :options="panelTypeOptions"
                                buttons
                                v-model="
                                  validationObj.currentVendorData.panelist
                                    .$model
                                "
                                @change="hidePanInIndep"
                                stacked
                              >
                              </b-form-radio-group>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="w-5 d-flex align-items-center justify-content-end"
                  >
                    <img
                      @click="saveCurrentVendor"
                      v-show="
                        isCurrentVenFilled &&
                        (validationObj.currentVendorData.noOfCandidatesToPush
                          .minValue ||
                          validationObj.currentVendorData.noOfCandidatesToPush
                            .maxLength)
                      "
                      src="../../../assets/img/newcreatejob/interviewprocess/addplus.svg"
                      alt=""
                      class="pointer"
                    />
                    <img
                      v-show="
                        !isCurrentVenFilled ||
                        !validationObj.currentVendorData.noOfCandidatesToPush
                          .minValue ||
                        !validationObj.currentVendorData.noOfCandidatesToPush
                          .maxLength
                      "
                      v-b-popover.hover.top="{
                        content: !isCurrentVenFilled
                          ? 'Please fill all details'
                          : !validationObj.currentVendorData
                              .noOfCandidatesToPush.maxLength
                          ? 'Candidates to push limit exceeded'
                          : 'Candidates to push should be more than 0',
                      }"
                      src="../../../assets/img/newcreatejob/interviewprocess/disableplus.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="newInt-required-validation-font mt-1"
                  v-if="
                    !validationObj.currentVendorData.noOfCandidatesToPush
                      .minValue
                  "
                >
                  Candidates to push should be more than 0
                </div>
                <div
                  class="newInt-required-validation-font mt-1"
                  v-else-if="
                    !validationObj.currentVendorData.noOfCandidatesToPush
                      .maxLength
                  "
                >
                  Candidates to push limit exceeded
                </div>
                <div
                  class="newInt-required-validation-font mt-1"
                  v-else-if="validationObj.currentVendorData.$error"
                >
                  Required
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <JobPositionModal
      v-if="showJobPosModal"
      :showJobPosModal="showJobPosModal"
      :onHold="jobData.onHold"
      @close-pos-status-modal="
        (showJobPosModal = false), $emit('calc-status-perc')
      "
    />
    <TransferPositionID
      v-if="showTransferModal"
      :showTransferModal="showTransferModal"
      :positionID="positionID"
      :buttonLoader="buttonLoader"
      @close-transfer-modal="onCloseTransferModal"
      @reassign-possition-id="reassignPossitionId"
    />
    <AllocateModal
      :showModal="showAllocateModal"
      :modalType="modalType"
      :userData="userData"
      :folderData="folderData"
      @store-allocate-data="storeAllocateData"
      @close-modal="showAllocateModal = false"
    />
    <AllocateVendor
      v-if="showAllocateVendor"
      :showAllocateVendor="showAllocateVendor"
      :vendorsData="commonVendorData.vendor"
      @hide-modal="showAllocateVendor = false"
      @assign-vendor="assignVender"
    />
    <AssignSinglePositionID
      v-if="showSingleAssign"
      id="Allocate"
      :showSingleAssign="showSingleAssign"
      :positionIDs="deleteRecruiterData.positionIDs"
      :candidate="deleteRecruiterData.candidate"
      @add-to-job="deleteRecruiterModal"
      @close-modal="closeSingleAssign"
    />
    <DeleteSinglePositionID
      v-if="showSingleDelete"
      :showSingleDelete="showSingleDelete"
      :positionIDDeleteData="positionIDDeleteData"
      :deletePosLoader="deletePosLoader"
      @close-modal="showSingleDelete = false"
      @delete-pos-id="deleteSinglePositionID"
    />
    <DeleteRecruiter
      v-if="openDeleteRecModal"
      :openDeleteRecModal="openDeleteRecModal"
      :jobID="$route.query.jobID"
      :userID="
        currentRecuiterData[this.deleteRecruiterData.index].recruiterData.userID
      "
      :recruiterName="deleteRecruiterData.candidate.name"
      @close-modal="(openDeleteRecModal = false), closeSingleAssign()"
      @go-back="openDeleteRecModal = false"
      @delete-success="deleteRecruiterManually"
    />
  </div>
</template>

<script>
import toast from "@/components/mixin/toast";
import DeleteRecruiter from "../modals/DeleteRecruiter.vue";
import AssignSinglePositionID from "@/components/Kanban/modal/AssignSinglePositionID.vue";
import DeleteSinglePositionID from "../modals/DeleteSinglePositionID.vue";
import TransferPositionID from "../modals/TransferPositionID.vue";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import AllocateModal from "../modals/AllocateModal.vue";
import AllocateVendor from "../modals/AllocateVendor.vue";
import JobPositionModal from "../modals/JobPositionModal.vue";
import { usersForList } from "../../../utils/apiClient/jobs";
import {
  getVendor,
  changePositionIds,
  deleteRecruiter,
  getCandidateCount,
  deletePositionID,
} from "../../../utils/apiFunctions";

export default {
  components: {
    AllocateModal,
    AllocateVendor,
    TransferPositionID,
    JobPositionModal,
    AssignSinglePositionID,
    DeleteSinglePositionID,
    DeleteRecruiter,
    draggable,
  },
  mixins: [toast],
  props: {
    positions: Array,
    positionBarPercentage: Array,
    tempVendor: Array,
    currentRecuiterData: Array,
    currentVendorData: Object,
    jobData: Object,
    allocateData: Object,
    validationObj: Object,
    interviewProcess: Object,
    commonVendorData: Object,
    isJdApproved: Boolean,
    applyToAll: Boolean,
    savedOpeningsCount: Number,
  },
  data() {
    return {
      suppressMovementType: null,
      deletePosLoader: false,
      showSingleDelete: false,
      showJobPosModal: false,
      showOptions: false,
      selectPosition: false,
      searchRecruiters: "",
      searchVendors: "",
      recruiterList: [],
      vendorsList: [],
      recruiterData: [],
      vendorPage: 0,
      totalVendors: 0,
      vendorPageEnd: 0,
      startIndex: null,
      endIndex: null,
      candidateStatus: null,
      positionID: "",
      openDeleteRecModal: false,
      showRecInIndex: false,
      showRecInComVendor: false,
      showPanelInComVendor: false,
      showRoundsToTake: false,
      showVendorLoader: false,
      isSelectAllRec: false,
      showPanel: false,
      showRecruiter: false,
      showVendor: false,
      showAllocateModal: false,
      showAllocateVendor: false,
      recLoader: false,
      buttonLoader: false,
      showVendorList: false,
      listenersAddedInRec: false,
      listenersAddedInVen: false,
      showTransferModal: false,
      showSingleAssign: false,
      localApplyToAll: this.applyToAll,
      modalType: null,
      folderData: [],
      userData: [],
      vendorsListIndep: [],
      clonedCurrentRecuiterData: [],
      panelTypeOptions: [
        { text: "Internal", value: "internal" },
        { text: "External", value: "external" },
        { text: "Both", value: "both" },
      ],
      options: [
        { text: "Select all Panelist", value: "allpanelist" },
        { text: "Select one or more Panelist", value: "partpanelist" },
        { text: "No Internal Panelist", value: "nopanelist" },
      ],
      configoptions: [
        { text: "Common", value: true },
        { text: "Independent", value: false },
      ],
      recruiteroptions: [
        { text: "Select one or more Recruiter", value: "partrecruiter" },
        { text: "No Internal Recruiter", value: "norecruiter" },
      ],
      deleteRecruiterData: {
        index: null,
        positionIDs: [],
        candidate: {},
      },
      positionIDDeleteData: {},
    };
  },
  created() {
    this.getRecruiterList();
  },
  watch: {
    applyToAll(newValue) {
      this.localApplyToAll = newValue;
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
      getLoggedInData: "getRoleValues",
    }),
    isRecruiterDataValid() {
      const lastRecruiterData = this.currentRecuiterData[0];
      return (
        lastRecruiterData &&
        lastRecruiterData.recruiterData !== null &&
        lastRecruiterData.positionIDs.length > 0 &&
        lastRecruiterData.selectedPanels.length > 0
      );
    },
    positionsLeft() {
      return this.positions.filter((position) => position.count === 0).length;
    },
    increaseMargin() {
      return (
        this.showVendorList ||
        this.currentVendorData.showVendor ||
        this.currentVendorData.showRounds ||
        this.currentVendorData.showRec
      );
    },
    draggableIDs() {
      return this.positions.map((position) => position.id);
    },
    isCurrentVenFilled() {
      const {
        vendor,
        noOfRoundsToTake,
        noOfCandidatesToPush,
        taggedRecruiters,
        panelist,
      } = this.currentVendorData;
      return (
        vendor !== null &&
        noOfRoundsToTake !== null &&
        noOfCandidatesToPush !== null &&
        taggedRecruiters.length &&
        ((noOfRoundsToTake == 0 && panelist === null) || panelist !== null)
      );
    },
    isCurrentRecEmpty() {
      const { panelist, noOfOpenings, recruiterData } =
        this.currentRecuiterData;
      return (
        panelist === null && noOfOpenings === null && recruiterData === null
      );
    },
    isCurrentRecFilled() {
      const { panelist, noOfOpenings, recruiterData } =
        this.currentRecuiterData;
      return (
        panelist !== null && noOfOpenings !== null && recruiterData !== null
      );
    },
    listPanels() {
      const userList = [];
      const assigned = this.allocateData.assignedPanelist;
      for (const user of assigned) {
        let found = false;
        for (const savedUser of userList) {
          if (user.userID === savedUser.userID) {
            found = true;
            break;
          }
        }
        if (!found) {
          userList.push(user);
        }
      }
      return userList;
    },
    listRecruiters() {
      const userList = [];
      const assigned = this.currentRecuiterData;
      for (const user of assigned) {
        if (user.recruiterData) {
          // Ensure recruiterData exists
          let found = false;
          for (const savedUser of userList) {
            if (user.recruiterData.userID === savedUser.userID) {
              found = true;
              break;
            }
          }
          if (!found) {
            userList.push(user.recruiterData);
          }
        }
      }
      return userList;
    },
    roundOptions() {
      let options = [];
      if (this.interviewProcess?.process) {
        const count = this.interviewProcess.process.length - 5;
        for (let i = 0; i <= count; i++) {
          options.push({ text: i, value: i });
        }
      }
      return options;
    },
    isLeadPresent() {
      let isPresent = false;
      for (const user of this.allocateData.assignedTo) {
        if (user.userID === this.getLoggedInData.userID) {
          isPresent = true;
          break;
        }
      }
      return isPresent;
    },
    selectedRecruiterList() {
      if (this.allocateData.assignedTo.length) {
        const recruiters = !this.isLeadPresent
          ? [this.getLoggedInData, ...this.listRecruiters]
          : this.listRecruiters;

        return recruiters.filter(
          (value, index, self) =>
            value &&
            value.userID &&
            index === self.findIndex((t) => t.userID === value.userID)
        );
      } else {
        if (
          this.getLoggedInData &&
          this.getLoggedInData.username.toLowerCase()
        ) {
          const recruiters = [this.getLoggedInData, ...this.listRecruiters];
          return recruiters.length > 0
            ? recruiters.filter(
                (value, index, self) =>
                  value &&
                  value.userID &&
                  index === self.findIndex((t) => t.userID === value.userID)
              )
            : [];
        }
        return [];
      }
    },
    isGreaterThanOpenings() {
      if (
        !isNaN(this.jobData.openingsCount) &&
        !isNaN(this.currentRecuiterData.noOfOpenings)
      ) {
        return (
          parseInt(this.currentRecuiterData.noOfOpenings) >
          parseInt(this.jobData.openingsCount)
        );
      }
      return false;
    },
    isOpeningsGiven() {
      return (
        this.jobData.openingsCount !== null && this.jobData.openingsCount !== ""
      );
    },
  },
  methods: {
    deleteRecruiterManually() {
      this.dynamicToast(
        "success",
        "Successfully Deleted",
        `Recruiter "${this.deleteRecruiterData.candidate.name}" has been deleted successfully.`
      );
      this.$emit("delete-recruiter-reload");
      this.openDeleteRecModal = false;
      this.closeSingleAssign();
    },
    deleteRecruiterModal(assignData) {
      if (assignData === "auto") {
        this.deleteRecruiterAutomatically();
      } else {
        this.openDeleteRecModal = true;
      }
    },
    async deleteRecruiterAutomatically() {
      try {
        let payload = {
          automatic: true,
          jobID: this.$route.query.jobID,
          user: this.currentRecuiterData[this.deleteRecruiterData.index]
            .recruiterData.userID,
        };
        let res = await deleteRecruiter(payload);
        if (res.status === 200) {
          this.dynamicToast(
            "success",
            "Successfully Deleted",
            `Recruiter "${this.deleteRecruiterData.candidate.name}" has been deleted successfully.`
          );
          this.$emit("delete-recruiter-reload");
          this.closeSingleAssign();
        }
      } catch (error) {
        console.error(error);
      }
    },
    deleteRecruiter(index) {
      if (
        !this.isJdApproved ||
        (this.isJdApproved &&
          this.currentRecuiterData[index].positionIDs.length === 0)
      ) {
        this.$emit("delete-recruiter", index);
        this.updateCounts();
      } else {
        this.showSingleAssign = true;
        this.deleteRecruiterData.index = index;
        this.deleteRecruiterData.positionIDs =
          this.currentRecuiterData[index].positionIDs;
        this.deleteRecruiterData.candidate.name =
          this.currentRecuiterData[index].recruiterData.username;
      }
    },
    closeSingleAssign() {
      this.showSingleAssign = false;
      this.deleteRecruiterData = {
        index: null,
        positionIDs: [],
        candidate: {},
      };
    },
    deletePositionID(index, posID) {
      if (!this.isJdApproved) {
        this.currentRecuiterData[index].positionIDs = this.currentRecuiterData[
          index
        ].positionIDs.filter((pos) => pos !== posID);
        this.updateCounts();
      } else {
        this.positionID = posID;
        this.startIndex = index;
        this.deletePositionIDonApproved(index);
      }
    },
    async deletePositionIDonApproved(index) {
      this.deletePosLoader = true;
      await this.checkForCandidates();
      if (this.candidateStatus === 200) {
        this.deletePositionIDWithoutCandidates(index);
      } else if (this.candidateStatus === 409) {
        this.startIndex = index;
        this.getInformationForDelete(index);
      }
    },
    async deletePositionIDWithoutCandidates(index) {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          positionID: this.positionID,
          recUserID: this.currentRecuiterData[index].recruiterData.userID,
        };
        let res = await deletePositionID(payload);
        if (res.status === 200) {
          this.currentRecuiterData[index].positionIDs =
            this.currentRecuiterData[index].positionIDs.filter(
              (pos) => pos !== this.positionID
            );
          this.updateCounts();
        }
      } catch (error) {
        console.error(error);
        this.errorToast("PositionID could not be deleted");
      } finally {
        this.deletePosLoader = false;
      }
    },
    async getInformationForDelete(index) {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          positionID: this.positionID,
          recUserID: this.currentRecuiterData[index].recruiterData.userID,
          type: 1,
        };
        let res = await getCandidateCount(payload);
        if (res.status === 200) {
          this.positionIDDeleteData = res.data.data;
          this.deletePosLoader = false;
          this.showSingleDelete = true;
        }
      } catch (error) {
        console.error(error);
        this.errorToast("PositionID could not be deleted");
        this.deletePosLoader = false;
      }
    },
    deleteSinglePositionID(positionIDArray) {
      if (positionIDArray && positionIDArray.length) {
        this.deletePositionManually(positionIDArray);
      } else {
        this.deletePositionAutomatically();
      }
    },
    async deletePositionAutomatically() {
      try {
        this.deletePosLoader = true;
        let payload = {
          jobID: this.$route.query.jobID,
          positionID: this.positionID,
          recUserID: this.positionIDDeleteData.userID,
          automatic: true,
        };
        let res = await deletePositionID(payload);
        if (res.status === 200) {
          this.currentRecuiterData[this.startIndex].positionIDs =
            this.currentRecuiterData[this.startIndex].positionIDs.filter(
              (pos) => pos !== this.positionID
            );
          this.updateCounts();
        }
      } catch (error) {
        console.error(error);
        this.errorToast("PositionID could not be deleted");
      } finally {
        this.deletePosLoader = false;
        this.showSingleDelete = false;
      }
    },
    async deletePositionManually(positionIDArray) {
      try {
        this.deletePosLoader = true;
        let payload = {
          jobID: this.$route.query.jobID,
          positionID: this.positionID,
          recUserID: this.positionIDDeleteData.userID,
          positionIDs: positionIDArray,
        };
        let res = await deletePositionID(payload);
        if (res.status === 200) {
          this.currentRecuiterData[this.startIndex].positionIDs =
            this.currentRecuiterData[this.startIndex].positionIDs.filter(
              (pos) => pos !== this.positionID
            );
          this.updateCounts();
        }
      } catch (error) {
        console.error(error);
        this.errorToast("PositionID could not be deleted");
      } finally {
        this.deletePosLoader = false;
        this.showSingleDelete = false;
      }
    },
    closeDropdownOnFocusOut(index) {
      setTimeout(() => {
        this.currentRecuiterData[index].showRecDropDown = false;
        this.$forceUpdate();
      }, 500);
    },
    onCloseTransferModal() {
      if (this.positionID) {
        this.currentRecuiterData[this.startIndex].positionIDs =
          this.clonedCurrentRecuiterData[this.startIndex].positionIDs;
        this.currentRecuiterData[this.endIndex].positionIDs =
          this.clonedCurrentRecuiterData[this.endIndex].positionIDs;
        this.updateCounts();
      }
      this.showTransferModal = false;
    },
    applyChangesToAllRecs() {
      this.$emit("toggle-apply-to-all");
      this.applyChangesToAll();
    },
    applyChangesToAll() {
      this.$emit("apply-changes-to-all");
    },
    async reassignPossitionId(movementType, minutes) {
      if (this.isJdApproved) {
        try {
          this.buttonLoader = true;
          this.setPanelists(this.endIndex);
          let positionIDs = this.positions.map((position) => position.id);
          let payload = {
            jobID: this.$route.query.jobID,
            positionID: this.positionID,
            movementType: parseInt(movementType),
            to: this.currentRecuiterData[this.endIndex].recruiterData,
            from: this.currentRecuiterData[this.startIndex].recruiterData
              .userID,
            positionIDs: positionIDs,
            suppressModalFor5Min: minutes,
          };
          let res = await changePositionIds(payload);

          if (res.status === 200) {
            this.$emit("update-assigned-to", res.data.data);
            this.$emit("calc-status-perc");
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.showTransferModal = false;
          this.buttonLoader = false;
        }
      }
    },
    setPanelists(index) {
      this.currentRecuiterData[index].recruiterData.panelist =
        this.currentRecuiterData[index].selectedPanels.includes("internal") &&
        this.currentRecuiterData[index].selectedPanels.includes("external")
          ? "both"
          : this.currentRecuiterData[index].selectedPanels.includes("internal")
          ? "internal"
          : this.currentRecuiterData[index].selectedPanels.includes("external")
          ? "external"
          : null;
    },
    getPositionById(id) {
      return (
        this.positions.find((position) => position.id === id) || { count: 0 }
      );
    },
    dragPositionID(index) {
      if (this.isJdApproved) {
        this.startIndex = index;
        this.clonedCurrentRecuiterData = JSON.parse(
          JSON.stringify(this.currentRecuiterData)
        );
      }
    },
    addPositionID(event, index) {
      if (this.savedOpeningsCount === null) {
        this.$emit("set-openings-count");
      }
      const recruiter = this.currentRecuiterData[index].positionIDs;
      this.currentRecuiterData[index].positionIDs = recruiter.filter(
        (value, index) => recruiter.indexOf(value) === index
      );
      // Update counts based on current positionIDs
      this.updateCounts();
      if (this.isJdApproved && event.from === this.$refs.firstDraggable.$el) {
        if (this.currentRecuiterData[index].recruiterData !== null) {
          this.updateRecruiter(index, event.item._underlying_vm_);
        } else {
          this.currentRecuiterData[index].positionIDs = [];
          this.updateCounts();
        }
      } else if (this.isJdApproved) {
        this.endIndex = index;
        this.positionID = event.item._underlying_vm_;
        if (
          this.endIndex !== this.startIndex &&
          this.currentRecuiterData[this.endIndex].recruiterData !== null
        ) {
          this.checkForCandidatesToTransfer();
        } else {
          this.onCloseTransferModal();
        }
      }
    },
    async checkForCandidatesToTransfer() {
      await this.checkForCandidates();
      if (this.candidateStatus === 200) {
        this.reassignPossitionId(this.suppressMovementType);
      } else if (this.candidateStatus === 409) {
        this.showTransferModal = true;
      }
    },
    async checkForCandidates() {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          type: 2,
          recUserID:
            this.currentRecuiterData[this.startIndex].recruiterData.userID,
          positionID: this.positionID,
        };
        let res = await getCandidateCount(payload);
        if (res.status === 200) {
          this.suppressMovementType = res.data.data.movementType;
          this.candidateStatus = 200;
        } else if (res.status === 409) {
          this.candidateStatus = 409;
        }
      } catch (error) {
        console.error(error);
      }
    },
    updateCounts() {
      // Reset counts first
      this.positions.forEach((position) => {
        position.count = 0;
      });
      this.currentRecuiterData.forEach((recruiter) => {
        recruiter.positionIDs.forEach((posID) => {
          const position = this.positions.find((pos) => pos.id === posID);
          if (position) {
            position.count += 1;
          }
        });
      });
    },
    async updateRecruiter(index, positionID) {
      if (this.isJdApproved) {
        try {
          this.setPanelists(index);
          let positionIDs = this.positions.map((position) => position.id);
          let payload = {
            jobID: this.$route.query.jobID,
            positionID: positionID,
            movementType: 0,
            to: this.currentRecuiterData[index].recruiterData,
            positionIDs: positionIDs,
          };
          let res = await changePositionIds(payload);

          if (res.status === 200) {
            this.$emit("update-assigned-to", res.data.data);
            this.$emit("calc-status-perc");
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    restrictInput(event) {
      if (
        (event.target.value.length >= 10 && event.key !== "Backspace") ||
        event.key == "e" ||
        event.key == "+" ||
        event.key == "-"
      ) {
        event.preventDefault();
        return;
      }
    },
    assignVender(vendorData) {
      this.showAllocateVendor = false;
      this.commonVendorData.vendor = vendorData;
    },
    openPanelInCommon() {
      if (this.commonVendorData.noOfRoundsToTake !== 0) {
        this.showPanelInComVendor = !this.showPanelInComVendor;
      }
    },
    checkRoundData(index) {
      if (this.tempVendor[index].noOfRoundsToTake === 0) {
        this.tempVendor[index].panelist = null;
      }
    },
    deleteVendor(index) {
      this.tempVendor.splice(index, 1);
    },
    checkToGetRecruiter(index) {
      let value = false;
      this.currentRecuiterData[index].showRecDropDown =
        !this.currentRecuiterData[index].showRecDropDown;
      value = this.currentRecuiterData[index].showRecDropDown;

      if (value) {
        this.recruiterList = [];
        let currentRecruiterUserIDs;

        if (this.currentRecuiterData.length > 1) {
          currentRecruiterUserIDs = this.currentRecuiterData
            .map((recruiter) => recruiter.recruiterData?.userID)
            .filter((userID) => userID !== undefined);
        } else {
          currentRecruiterUserIDs = [
            this.currentRecuiterData[index].recruiterData?.userID,
          ].filter((userID) => userID !== undefined);
        }

        const currentRecruiter = this.currentRecuiterData[index].recruiterData;
        if (currentRecruiter) {
          this.recruiterList.push({
            text: currentRecruiter.username,
            value: currentRecruiter.userID,
          });
        }

        this.recruiterList = [
          ...this.recruiterList,
          ...this.recruiterData
            .filter(
              (recruiter) => !currentRecruiterUserIDs.includes(recruiter.userID)
            )
            .map((recruiter) => ({
              text: recruiter.username,
              value: recruiter.userID,
            })),
        ];
      }
      this.$forceUpdate();
    },
    modifyRecruiterOption() {
      this.allocateData.recruiterConfig.panelist = null;
      this.allocateData.assignedTo = [];
      this.allocateData.userFolderIDs.Recruiters = [];
    },
    modifyPanelData() {
      switch (this.allocateData.requiredPanel) {
        case "allpanelist":
          this.allocateData.showAllPanelist = true;
          break;
        case "nopanelist":
          this.allocateData.showAllPanelist = false;
          if (this.panelTypeOptions.length === 3) {
            this.panelTypeOptions.shift();
            this.panelTypeOptions.pop();
            this.checkFilledPanelData();
          }
          break;
        default:
          this.allocateData.showAllPanelist = false;
      }
      if (this.allocateData.requiredPanel !== "nopanelist") {
        if (this.panelTypeOptions.length === 1) {
          this.panelTypeOptions.unshift({
            text: "Internal",
            value: "internal",
          });
          this.panelTypeOptions.push({
            text: "Both",
            value: "both",
          });
        }
      }
      this.allocateData.assignedPanelist = [];
      this.allocateData.userFolderIDs.Panelist = [];
      this.$forceUpdate();
    },
    checkFilledPanelData() {
      if (this.allocateData.recruiterConfig.common) {
        if (this.allocateData.recruiterConfig.panelist) {
          this.allocateData.recruiterConfig.panelist = "external";
        }
      } else {
        if (this.currentRecuiterData.panelist) {
          this.currentRecuiterData.panelist = "external";
        }
      }
      if (this.allocateData.vendorConfig.common) {
        if (this.commonVendorData.panelist) {
          this.commonVendorData.panelist = "external";
        }
      } else {
        if (this.currentVendorData.panelist) {
          this.currentVendorData.panelist = "external";
        }
        for (const vendor of this.tempVendor) {
          vendor.panelist = "external";
        }
      }
    },
    closeTempVendorVenOnClickOutside(event) {
      this.searchRecruiters = "";
      for (let i = 0; i < this.tempVendor.length; i++) {
        if (
          this.$refs["label-indexed-ven-" + i] &&
          !this.$refs["label-indexed-ven-" + i][0].contains(event.target)
        ) {
          this.tempVendor[i].showVendor = false;
        }
      }
    },
    hidePanInIndep() {
      this.currentVendorData.showPanel = false;
    },
    hideRecInVenIndep() {
      this.currentVendorData.showRec = false;
    },
    hideRoundInVenIndep() {
      if (this.currentVendorData.noOfRoundsToTake === 0) {
        this.currentVendorData.panelist = null;
      }
      this.currentVendorData.showRounds = false;
    },
    openPanel(index) {
      if (index !== null && typeof index === "number") {
        if (this.tempVendor[index].noOfRoundsToTake !== 0) {
          this.tempVendor[index].showPanel = !this.tempVendor[index].showPanel;
        }
      } else if (this.currentVendorData.noOfRoundsToTake !== 0) {
        this.currentVendorData.showPanel = !this.currentVendorData.showPanel;
      }
    },
    hideVendorInIndep() {
      this.searchVendors = "";
      this.currentVendorData.showVendor = false;
      this.$forceUpdate();
    },
    closeVendorVenOnClickOutside(event) {
      this.searchRecruiters = "";
      for (let i = 0; i < this.tempVendor.length; i++) {
        if (
          this.$refs["label-indexed-ven-" + i] &&
          !this.$refs["label-indexed-ven-" + i][0].contains(event.target)
        ) {
          this.tempVendor[i].showVendor = false;
        }
      }
    },
    closeOnFocusOut(event, ref, index, data, key) {
      this.searchRecruiters = "";
      this.searchVendors = "";
      if (
        this.$refs[ref] &&
        !this.$refs[ref][0].contains(event.relatedTarget)
      ) {
        this[data][index][key] = false;
      }
    },
    hideDropDown() {
      this.showRecInComVendor = false;
    },
    hidePanelForVendor() {
      this.showPanelInComVendor = false;
    },
    hideNoOfRounds() {
      this.showRoundsToTake = false;
      if (this.commonVendorData.noOfRoundsToTake === 0) {
        this.commonVendorData.panelist = null;
      }
    },
    closeVendor() {
      this.showVendorList = false;
    },
    async openVendorsIndep(event, index) {
      let value = false;
      if (index >= 0) {
        this.tempVendor[index].showVendor = !this.tempVendor[index].showVendor;
        value = this.tempVendor[index].showVendor;
      } else {
        this.currentVendorData.showVendor = !this.currentVendorData.showVendor;
        value = this.currentVendorData.showVendor;
      }
      if (value) {
        this.resetVendorData();
        await this.getVendors(index);
      }
    },
    resetVendorData() {
      this.searchVendors = "";
      this.vendorsList = [];
      this.vendorPage = 0;
      this.totalVendors = 0;
      this.vendorPageEnd = 0;
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    onVenScroll(e) {
      // Get the target element of the scroll event.
      const { target } = e;
      // Check if the user has reached the bottom of the scrollable area.
      if (
        Math.ceil(target.scrollTop) + 1 >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.

        if (this.checkbetween(this.vendorPageEnd, 0, this.totalVendors)) {
          this.vendorPage++;
          this.getVendors();
        }
      }
    },
    async getVendors(indepIndex = null) {
      this.showVendorLoader = true;
      try {
        let payload = {
          type: 1,
          searchQuery: this.searchVendors,
          sortColumn: "updatedAt",
          sortOrder: "-1",
          page: this.vendorPage,
          count: 15,
        };
        const response = await getVendor(payload);
        if (response.status == 200) {
          if (this.vendorPage == 0) {
            this.vendorsList = response.data.data.data;
          } else {
            this.vendorsList = [
              ...this.vendorsList,
              ...response.data.data.data,
            ];
          }
          this.totalVendors = response.data.data.total;
          this.vendorPageEnd = response.data.data.pageEnd;
          if (!this.allocateData.vendorConfig.common) {
            const set = new Set();
            for (const vendor of this.tempVendor) {
              set.add(vendor.vendor.vendorID);
            }
            if (indepIndex !== null && typeof indepIndex === "number") {
              if (set.has(this.tempVendor[indepIndex].vendor.vendorID)) {
                set.delete(this.tempVendor[indepIndex].vendor.vendor);
              }
              if (this.currentVendorData.vendor) {
                set.add(this.currentVendorData.vendor.vendorID);
              }
            }
            for (const i in this.vendorsList) {
              let user = this.vendorsList[i];
              if (user.text) {
                continue;
              }
              const data = {
                text: user.name,
                value: {
                  vendorID: user.vendorID,
                  vendorUserID: user.vendorUserID,
                  email: user.email,
                  name: user.name,
                },
              };
              this.vendorsList[i] = data;
            }
            let index = 0;
            while (index > -1 && index < this.vendorsList.length) {
              if (set.has(this.vendorsList[index].value.vendorID)) {
                this.vendorsList.splice(index, 1);
                continue;
              }
              index++;
            }
          }
        }
        this.showVendorLoader = false;
      } catch (error) {
        this.showVendorLoader = false;
        console.error(error);
      }
    },
    saveCurrentVendor() {
      this.validationObj.currentVendorData.$touch();
      if (!this.validationObj.currentVendorData.$invalid) {
        this.tempVendor.push({ ...this.currentVendorData });
        this.$emit("clear-vendor");
        this.validationObj.currentVendorData.$reset();
        if (this.listenersAddedInVen) {
          document.removeEventListener(
            "click",
            this.closeVendorVenOnClickOutside
          );
        }
        document.addEventListener("click", this.closeVendorVenOnClickOutside);
        this.listenersAddedInVen = true;
      }
    },
    hideIndepPanel() {
      this.currentRecuiterData.showPanelDropDown = false;
    },
    hideRecruiter(index) {
      this.currentRecuiterData[index].showRecDropDown = false;

      let recruiter = null;
      this.recruiterData.forEach((rec) => {
        if (rec.userID === this.currentRecuiterData[index].selectedRecruiter) {
          recruiter = rec;
        }
      });
      this.currentRecuiterData[index].recruiterData = recruiter;
    },
    async getRecruiterList() {
      this.allocateData.recruiterConfig.panelist = null;
      this.allocateData.assignedTo = [];
      this.allocateData.recruiterConfig.requiredRecruiter = "partrecruiter";
      this.recLoader = true;
      try {
        const payload = {
          searchQuery: this.searchRecruiters,
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          permission: "GET_JOBDASHBOARD",
        };

        const response = await usersForList(payload);
        if (response.status === 200) {
          this.recruiterData = response.data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.recLoader = false;
      }
    },
    hideSelectAllRec() {
      this.isSelectAllRec = false;
    },
    removePanel(userID) {
      this.$emit("remove-panel", userID);
    },
    storeAllocateData(userData, folderIDs) {
      if (this.modalType === "panelist") {
        this.allocateData.assignedPanelist = userData;
        this.allocateData.userFolderIDs.Panelist = folderIDs;
      } else {
        this.allocateData.assignedTo = userData;
        this.allocateData.userFolderIDs.Recruiters = folderIDs;
      }
      this.showAllocateModal = false;
    },
    openModal(data) {
      if (data === "panelist") {
        this.userData = this.allocateData.assignedPanelist;
        this.folderData = this.allocateData.userFolderIDs.Panelist;
      } else {
        this.userData = this.allocateData.assignedTo;
        this.folderData = this.allocateData.userFolderIDs.Recruiters;
      }
      this.showAllocateModal = true;
      this.modalType = data;
    },
    toggleView(data) {
      if (
        data === "showVendor" &&
        (this.interviewProcess === null ||
          !Object.keys(this.interviewProcess).length)
      ) {
        return;
      }
      this[data] = !this[data];
    },
  },
};
</script>

<style scoped>
.allocate-req-dropdown-height {
  height: 200px;
}

.allocate-req-dropdown {
  max-height: 200px;
  min-height: auto;
  overflow-y: auto;
}

.disabled-color {
  background-color: #eeeeee;
}

.mb-10r {
  margin-bottom: 10rem;
}

.dropdown-height-allocate {
  max-height: 200px;
  min-height: auto;
  overflow: auto;
}

.dropdown-height-allocate-2 {
  max-height: 170px;
  min-height: auto;
  overflow: auto;
}

.m-15-25 {
  margin: 15px 25px;
}

.allocate-tablecard-line-error {
  position: absolute;
  width: 3px;
  height: 100%;
  background: red;
  border-radius: 1px;
  left: 5px;
  top: 0;
}

.allocate-rounds-group-container {
  min-height: auto;
  max-height: 100px;
  overflow-y: auto;
}

.new-allocate-subhead {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
}

.panel-unselected-div {
  padding: 9px 16px;
  width: 110px;
  height: 30px;
  background: #f4f4f4;
  border-radius: 8px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: var(--bluetheme);
}

.panel-selected-div {
  padding: 9px 16px;
  width: 110px;
  height: 30px;

  background: var(--bluetheme);
  border-radius: 8px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.position-status-font {
  font-family: "Lato", sans-serif;
  font-style: italic;
  font-weight: 600;
  font-size: 12px;
  color: var(--bluetheme);
}

.red-line {
  height: 5px;
  background: #ec0b05;
  border-radius: 2px;
}

.orange-line {
  height: 5px;
  background: #f28a2b;
  border-radius: 2px;
}

.green-line {
  height: 5px;
  background: #289604;
  border-radius: 2px;
}

.grey-line {
  height: 5px;
  background: #6c757d;
  border-radius: 2px;
}

.golden-line {
  height: 5px;
  background: #e4b320;
  border-radius: 2px;
}

.position-id-subtext {
  font-family: "Lato", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  color: #8c8c8c;
}
.apply-font {
  font-family: "Lato", sans-serif;
  font-style: italic;
  font-weight: 600;
  font-size: 13px;
  color: #3a3c40;
}

.gap-15px {
  gap: 15px;
}

.allocate-opacity-class {
  opacity: 50%;
  cursor: default;
}
</style>
